import type React from 'react';

import { Divider, FormField, Input, Label } from '@zillow/constellation-10';
import { Box } from '@zillow/constellation-10';

import HeaderToggle from './HeaderToggle';
import type { Section } from '../../../../models/index';
import { TRASH_REMOVAL } from '../../../../constants';
import YesAndNo from '../../../Widgets/YesAndNo';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

const INITIAL_STATE = {
  [TRASH_REMOVAL.FIELD_NAME.IS_ENABLED]: true,
  [TRASH_REMOVAL.FIELD_NAME.SERVICE_PROVIDER]: '',
};

export default function TrashRemoval_v2({ section, setSectionValues }: Props): JSX.Element {
  function toggleUtility(): void {
    setSectionValues({
      ...INITIAL_STATE,
      [TRASH_REMOVAL.FIELD_NAME.IS_ENABLED]: !section.getFieldValue(TRASH_REMOVAL.FIELD_NAME.IS_ENABLED),
    });
  }

  function setServiceProvider(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void {
    setSectionValues({
      [TRASH_REMOVAL.FIELD_NAME.SERVICE_PROVIDER]: event.currentTarget.value,
    });
  }

  function yesDeliveredToAreas(): void {
    setSectionValues({
      [TRASH_REMOVAL.FIELD_NAME.DELIVERED_TO_AREAS_OTHER_THAN_TENANTS_UNIT]: true,
    });
  }

  function noDeliveredToAreas(): void {
    setSectionValues({
      [TRASH_REMOVAL.FIELD_NAME.DELIVERED_TO_AREAS_OTHER_THAN_TENANTS_UNIT]: false,
    });
  }

  return (
    <>
      <HeaderToggle
        header="Trash removal"
        subheader="Tenant pays in addition to rent"
        switchOn={section.getFieldValue(TRASH_REMOVAL.FIELD_NAME.IS_ENABLED)}
        onSwitchToggle={toggleUtility}
      />
      {section.getFieldValue(TRASH_REMOVAL.FIELD_NAME.IS_ENABLED) && (
        <>
          <Divider css={{ marginTop: 'layout.tighter', marginBottom: 'layout.tighter' }} />
          <FormField
            required
            css={{ marginBottom: 'layout.tight' }}
            label={
              <Label id="service-provider">
                Your tenant will be responsible for cost and account set up and will pay directly to which service
                provider?
              </Label>
            }
            control={
              <Input
                aria-labelledby="service-provider"
                value={section.getFieldValue(TRASH_REMOVAL.FIELD_NAME.SERVICE_PROVIDER)}
                onChange={setServiceProvider}
                data-test="service-provider"
              />
            }
          />
          <Label>Will this trash removal service be delivered to areas other than the tenant’s unit?</Label>
          <Box css={{ marginTop: 'layout.tighter' }} />
          <YesAndNo
            yesHandler={yesDeliveredToAreas}
            noHandler={noDeliveredToAreas}
            yesActive={section.getFieldValue(TRASH_REMOVAL.FIELD_NAME.DELIVERED_TO_AREAS_OTHER_THAN_TENANTS_UNIT)}
          />
        </>
      )}
    </>
  );
}
